/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Post Payment Button - Simplified component that accepts onClick and disabled props
 */
import { Button, ButtonProps } from 'antd';
import { Edit } from '@icon-park/react';

type IPostPaymentButtonProps = ButtonProps & {
	onClick?: VoidFunction;
	disabled?: boolean;
	shouldShow?: boolean;
	isArchivedClaim?: boolean;
	showPostPaymentVoidConditions?: boolean;
	hasDraftClaims?: boolean;
};

const PostPaymentButton: React.FC<IPostPaymentButtonProps> = ({
	onClick,
	disabled,
	shouldShow = true,
	isArchivedClaim = false,
	showPostPaymentVoidConditions = false,
	hasDraftClaims = false,
	...restProps
}) => {
	if (!shouldShow || !onClick || isArchivedClaim || !showPostPaymentVoidConditions) {
		return null;
	}

	return (
		<Button type='primary' disabled={disabled} {...restProps} onClick={onClick} icon={hasDraftClaims ? <Edit /> : undefined}>
			{'Post Payment'}
		</Button>
	);
};

export default PostPaymentButton;
